<template>
  <v-layout row wrap>
    <v-flex lg1 xs12>
      <v-checkbox class="align-end justify-end" color="primary" v-model="mainForm.drCrNo" readonly></v-checkbox>
    </v-flex>
    <v-flex lg3 xs12>
      <v-text-field v-model="mainForm.acct1DocNo" :label="labels.acct1DocNo" :error-messages="errors.collect('acct1DocNo')" data-vv-name="acct1DocNo" :data-vv-as="labels.acct1DocNo" v-validate="'max:8'" :disabled="mainForm.drCrNo" readonly></v-text-field>
    </v-flex>
    <v-flex lg1 xs12>
    </v-flex>
    <v-flex lg3 xs12>
      <v-checkbox color="primary" v-model="mainForm.prtInsdDr" :label="labels.prtInsdDr" readonly></v-checkbox>
    </v-flex>
    <v-flex lg4 xs12>
      <v-text-field v-model="mainForm.totNoInstal" :label="labels.totNoInstal" :error-messages="errors.collect('totNoInstal')" data-vv-name="totNoInstal" :data-vv-as="labels.totNoInstal" v-validate="'max:8'" :disabled="!perInstal" readonly></v-text-field>
    </v-flex>
    <v-flex lg1 xs12>
    </v-flex>
    <v-flex lg3 xs12>
      <v-text-field v-model="mainForm.rcptNo" :label="labels.rcptNo" :error-messages="errors.collect('rcptNo')" data-vv-name="rcptNo" :data-vv-as="labels.rcptNo" v-validate="'max:7'" readonly></v-text-field>
    </v-flex>
    <v-flex lg1 xs12>
    </v-flex>
    <v-flex lg3 xs12>
      <v-checkbox color="primary" v-model="mainForm.entRilater" :label="labels.entRilater" readonly></v-checkbox>
    </v-flex>
  </v-layout>
</template>

<script>
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'

export default {
  data () {
    return {
      labels: {
        title: 'Additional Settings',
        acct1DocNo: 'Debit / Credit Note',
        prtInsdDr: 'Print name of insured on Debit Note',
        totNoInstal: 'No. of Instalments',
        rcptNo: 'Receipt No',
        entRilater: 'Enter Reinsurance later'
      },
      mainForm: {
        drCrNo: undefined,
        acct1DocNo: undefined,
        prtInsdDr: undefined,
        totNoInstal: undefined,
        rcptNo: undefined,
        entRilater: undefined
      },
      perInstal: false,
      loading: false
    }
  },
  computed: {
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    }
  },
  methods: {
    doInit() {
      this.mainForm.drCrNo = this.polMaster.drCrNo
      this.mainForm.acct1DocNo = this.polMaster.acct1DocNo
      this.mainForm.prtInsdDr = this.polMaster.prtInsdDr
      this.mainForm.totNoInstal = this.polMaster.totNoInstal
      this.mainForm.rcptNo = this.polMaster.rcptNo
      this.mainForm.entRilater = this.polMaster.entRilater
      this.getAdditionalSettings()
    },
    async getAdditionalSettings() {
      const apiUrl = this.$store.state.underwriting.policySummarySettings.menu.additionalSettings
      if (apiUrl) {
        try {
          this.loading = true

          const expand = {
            polType: this.polMaster.polType
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))

          const { data } = result
          if (data) {
            this.perInstal = data.perInstal
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  beforeMount() {
    if (this.$store.state.underwriting.policySummarySettings.init === 1) {
      this.doInit()
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style>

</style>
